import React from 'react'
import Translator from '../Translator.js'
import { useModalContext } from '../context/ModalContext.js'

function Drink() {
  const {showModal, setShowModal, data, setData} = useModalContext()
  let l = Translator()


  const Urunler = [
    {
      ad: l.Drinks.icecek1,  
      img: "#",
      fiyat: '30',
    },
    {
      ad: l.Drinks.icecek2,  
      img: "#",
      fiyat: '30',
    },
    {
      ad: l.Drinks.icecek21,  
      img: "#",
      fiyat: '25',
    },
    {
      ad: l.Drinks.icecek3,  
      img: "#",
      fiyat: '30',
    },
    {
      ad: l.Drinks.icecek4,  
      img: "#",
      fiyat: '30',
    },
    {
      ad: l.Drinks.icecek5,  
      img: "#",
      fiyat: '30',
    },
    {
      ad: l.Drinks.icecek6,  
      img: "#",
      fiyat: '30',
    },
    {
      ad: l.Drinks.icecek7,  
      img: "#",
      fiyat: '30',
    },
    {
      ad: l.Drinks.icecek8,  
      img: "#",
      fiyat: '40',
    },
    {
      ad: l.Drinks.icecek9,  
      img: "#",
      fiyat: '40',
    },
    {
      ad: l.Drinks.icecek10,  
      img: "#",
      fiyat: '40',
    },
    {
      ad: l.Drinks.icecek11,  
      img: "#",
      fiyat: '10',
    },
    {
      ad: l.Drinks.icecek12,  
      img: "#",
      fiyat: '15',
    },
    {
      ad: l.Drinks.icecek13,  
      img: "#",
      fiyat: '50',
    },
    {
      ad: l.Drinks.icecek14,  
      img: "#",
      fiyat: '7.5',
    },
    {
      ad: l.Drinks.icecek20,  
      img: "#",
      fiyat: '10',
    },
    {
      ad: l.Drinks.icecek15,  
      img: "#",
      fiyat: '7',
    },
    {
      ad: l.Drinks.icecek16,  
      img: "#",
      fiyat: '25',
    },
    {
      ad: l.Drinks.icecek17,  
      img: "#",
      fiyat: '25',
    },
    {
      ad: l.Drinks.icecek18,  
      img: "#",
      fiyat: '7.5',
    },
    {
      ad: l.Drinks.icecek19,  
      img: "#",
      fiyat: '20',
    },
    {
      ad: l.Drinks.icecek22,  
      img: "#",
      fiyat: '35',
    },
    {
      ad: l.Drinks.icecek23,  
      img: "#",
      fiyat: '35',
    },
    {
      ad: l.Drinks.icecek24,  
      img: "#",
      fiyat: '20',
    },

  ]
  return (
    <div>
      <div className="flex flex-col w-full p-5 border-b-4 border-gray-700">
        <h1 className="text-4xl font-bold text-red-600 text-center">{l.Main.btn3}</h1>
        {Urunler.map((item, i) => [
          <div key={i}>
          <div className="flex flex-col items-left justify-between py-2 border-4 mt-2 shadow-xl rounded-sm border-gray-700">
            <div className="cursor-pointer text-xl px-5 font-semibold">{item.ad}</div>
            <div className="text-md px-5 font-black text-blue-600">{item.fiyat}₺</div>
          </div>
        </div>
        ])}
      </div>
    </div>
  )
}

export default Drink
